import { Component, Host, h , Prop,  State} from '@stencil/core';

@Component({
  tag: 'loader-component',
  styleUrl: 'loader-component.css',
  scoped: true
})
export class LoaderComponent {

   
  render() {
    return (
<div class="ph-item">
      <div>
        <div class="ph-row">
          <div class="ph-col-10 big"></div>
          <div class="ph-col-2 empty big "></div>
          <div class="ph-col-4 "></div>
          <div class="ph-col-8 empty"></div>
          <div class="ph-col-6 "></div>
          <div class="ph-col-6 empty "></div>
          <div class="ph-col-12 "></div></div>
        <div class="ph-row ">
          <div class="ph-col-4 "></div>
          <div class="ph-col-8 empty"></div>
          <div class="ph-col-6 "></div>
          <div class="ph-col-6 empty"></div>
          <div class="ph-col-2"></div>
          <div class="ph-col-10 empty "></div></div></div></div>
    );
  }

}
